import React from 'react';

import { IPdfDocumentControls } from '../../../ui/types/IPdfDocumentControls';

import Pin from '../../../ui/button/pin/pin';
import Icon from '../../../ui/icon/icon';

import './pdfDocumentControls.scss';

const PdfDocumentControls: React.FC<IPdfDocumentControls> = ({
                                                               expand,
                                                               onBackClick,
                                                               collapseClick,
                                                               expandClick,
                                                               onDownload,
                                                               onPrint,
                                                               onZoomOut,
                                                               zoom,
                                                               onZoomIn,
                                                               onPreviousPage,
                                                               page,
                                                               numPages,
                                                               onNextPage,
                                                               onPin,
                                                               pinned,
                                                               shouldPin,
                                                               backgroundColor,
                                                             }) => {
  return (
    <div className='pdf-controls' style={{ background: backgroundColor }}>
      <div className='controls'>
        <div className='btn-group hidden-mobile'>
            <span className='pointer' onClick={onPrint}>
              <Icon name={'fa-regular fa-print'} />
            </span>
        </div>
        <div className='btn-group'>
            <span className='pointer' onClick={onZoomOut}>
              <Icon name={'fa-regular fa-search-minus'} />
            </span>
          <div className='no-padding number-text center-text'>{Math.round(zoom * 100)} %</div>
          <span className='pointer' onClick={onZoomIn}>
              <Icon name={'fa-regular fa-search-plus'} />
            </span>
        </div>

        <div className='btn-group'>
            <span className='pointer' onClick={onPreviousPage}>
              <Icon name={'fa-regular fa-chevron-left'} />
            </span>
          <span>
              <span className='no-padding number-text'>{page}</span>
              <span className='no-padding number-text'>/ </span>
              <span className='no-padding number-text'> {numPages}</span>
            </span>
          <span className='pointer' onClick={onNextPage}>
              <Icon name={'fa-regular fa-chevron-right'} />
            </span>
        </div>
        <div className='btn-group hidden-mobile'>
            <span className='pointer' onClick={onPin}>
              {shouldPin ? <Pin isPinned={pinned} /> : null}
            </span>
        </div>
        <div className='side-controls'>
          <div className='btn-group'>
            <span className='pointer' onClick={onDownload}>
              <Icon name={'fa-regular fa-file-download'} />
            </span>
          </div>
          {expand ? (
            <div className='btn-group'>
                <span className='pointer'>
                  <Icon onClick={collapseClick} name={'fa-regular fa-compress'} className={'expand-compress'} />
                </span>
            </div>
          ) : (
            <div className='btn-group'>
                <span className='pointer'>
                  <Icon onClick={expandClick} name={'fa-regular fa-expand'} className={'expand-compress'} />
                </span>
            </div>
          )}
          <div className='btn-group'>
              <span className='pointer'>
                <Icon onClick={onBackClick} name={'fa-solid fa-circle-xmark'} className={'close-doc'} />
              </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfDocumentControls;